<mat-dialog-content class="text-center">
	<p>
		{{message}}
	</p>
</mat-dialog-content>
<mat-dialog-actions class="row no-gutters col-12 d-flex align-items-center justify-content-center pb-4">
	<button class="btn btn-primary button mx-2 col" (click)="onConfirmClick()" tabindex="1">{{confirmButtonText}}</button>
	<button class="btn btn-outline-secondary mx-2 col" (click)="cancel()" tabindex="-1">{{cancelButtonText}}</button>
</mat-dialog-actions>